import { type FormComponentBaseProps } from "@common/controls/Form/Field/component";
import { PaymentElement } from "@stripe/react-stripe-js";
import { type StripePaymentElementChangeEvent } from "@stripe/stripe-js";
import classNames from "classnames";
import React from "react";

export type StripeCartInputProps = FormComponentBaseProps & {
  onChange?: (value: string) => void;
};
const StripePaymentInput = (props: StripeCartInputProps) => {
  const onChange = React.useCallback(
    (e: StripePaymentElementChangeEvent) => {
      if (e.complete && props.onChange) props.onChange("dummy");
    },
    [props.onChange]
  );

  return (
    <div className={classNames(props.className, "card_input")}>
      <PaymentElement onChange={onChange} />
    </div>
  );
};
export default StripePaymentInput;
